import { render, staticRenderFns } from "./AreaSalesIndex.vue?vue&type=template&id=a2f58ea0"
import script from "./AreaSalesIndex.vue?vue&type=script&lang=js"
export * from "./AreaSalesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports